
import {useState, useEffect} from 'react';
import './profiles.css';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import api from '../../../config.js';
import { Link, useHistory, useParams } from 'react-router-dom';
import { FaArrowAltCircleLeft, FaCog, FaMinus, FaPlus } from 'react-icons/fa';
import ReactTooltip from "react-tooltip";
import { changeDisable } from '../../../services/Cadastros/service';
import { getPermission, showMessageError } from '../../../classes/functions';

export default function Profiles(){
  const { option, id } = useParams();
  const history = useHistory();
  const [view, setView] = useState(false);
  const [carrying, setCarrying] = useState(true);

  const [nome, setNome] = useState('');
  const [mainModules, setMainModules] = useState([]);
  
  useEffect(()=> {
    async function loadProfile(){
      if (id) { 
        getOne(id, option);
      } else {
        getData();
      }
    }

    loadProfile();

  }, []);

  function save(e){
    setCarrying(true);
    e.preventDefault();
        
    let listAux = [];

    mainModules.forEach(element => {
      if (element.checked) {
        listAux.push(element.id);
      }
      element.modules.forEach(second_element => {
        if (second_element.checked) {
          listAux.push(second_element.id);
        }
        second_element.modules.forEach(third_element => {
          if (third_element.checked) {
            listAux.push(third_element.id);
          }
          third_element.modules.forEach(fourth_element => {
            if (fourth_element.checked) {
              listAux.push(fourth_element.id);
            }
          });
        });
      });
    });

    const data = {
      row: {
        nome: nome,
        permissoes: listAux
      }
    }

    if (id) { 
      data.row.id = id;
      api.put("/api/profiles/put", data)
      .then((response) => {
          toast.success('Registro atualizado com sucesso.');
          history.push('/profiles');
        }
      ).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
    } else {
      api.post("/api/profiles/post", data)
      .then((response) => {
          toast.success('Registro inserido com sucesso.');
          history.push('/profiles');
        }
      ).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
    }
  }

  function getOne(id, option){
    api.get("/api/profiles/getList?id=" + id)
    .then((response) => {
        setNome(response.data.row.nome);
        carregaModulos(response.data.permissoes);
        
        setCarrying(false);
      }
    ).catch((error) => {
      showMessageError(error.response.data);
      setCarrying(false);
    });
    
    setView(changeDisable(option));
  }

  function cancel(){
    history.push('/profiles');
  }

  function remove(){
    api.delete("/api/profiles/delete?id=" + id)
    .then((response) => {
        toast.success('Registro excluído com sucesso.');
        history.push('/profiles');
      }
    ).catch((error) => {
      showMessageError(error.response.data);
    });
  }

  function changeListPermission(index, secondLevel = null, thirdLevel = null, fourthLevel = null) {
    let aux = [];
    
    mainModules.forEach((element, inx) => {
      if (inx === index) {
        if (fourthLevel !== null) {
          element.modules[secondLevel].modules[thirdLevel].modules[fourthLevel].checked = !element.modules[secondLevel].modules[thirdLevel].modules[fourthLevel].checked;
          if (element.modules[secondLevel].modules[thirdLevel].modules[fourthLevel].checked) {
            element.modules[secondLevel].modules[thirdLevel].checked = true;
            element.modules[secondLevel].checked = true;
            element.checked = true;
          }
        } else if (thirdLevel !== null) {
          element.modules[secondLevel].modules[thirdLevel].checked = !element.modules[secondLevel].modules[thirdLevel].checked;
          if (element.modules[secondLevel].modules[thirdLevel].checked) {
            element.modules[secondLevel].checked = true;
            element.checked = true;
          }
          for (let i = 0; i < element.modules[secondLevel].modules[thirdLevel].modules.length; i++) {
            element.modules[secondLevel].modules[thirdLevel].modules[i].checked = element.modules[secondLevel].modules[thirdLevel].checked;
          }
        } else if (secondLevel !== null) {
          element.modules[secondLevel].checked = !element.modules[secondLevel].checked;
          if (element.modules[secondLevel].checked) {
            element.checked = true;
          }
          for (let i = 0; i < element.modules[secondLevel].modules.length; i++) {
            element.modules[secondLevel].modules[i].checked = element.modules[secondLevel].checked;
            for (let j = 0; j < element.modules[secondLevel].modules[i].modules.length; j++) {
              element.modules[secondLevel].modules[i].modules[j].checked = element.modules[secondLevel].checked;
            }
          }
        } else {
          element.checked = !element.checked;
          for (let i = 0; i < element.modules.length; i++) {
            element.modules[i].checked = element.checked;
            for (let j = 0; j < element.modules[i].modules.length; j++) {
              element.modules[i].modules[j].checked = element.checked;
              for (let k = 0; k < element.modules[i].modules[j].modules.length; k++) {
                element.modules[i].modules[j].modules[k].checked = element.checked;
              }
            }
          }
        }
      }
      aux.push(element)
    });
    
    setMainModules(() => aux);
  }
  
  async function chengeView(index, secondLevel = null, thirdLevel = null, fourthLevel = null) {
    let aux = [];
    
    mainModules.forEach((element, inx) => {
      if (inx === index) {
        if (fourthLevel !== null) {
          element.modules[secondLevel].modules[thirdLevel].modules[fourthLevel].view = !element.modules[secondLevel].modules[thirdLevel].modules[fourthLevel].view;
        } else if (thirdLevel !== null) {
          element.modules[secondLevel].modules[thirdLevel].view = !element.modules[secondLevel].modules[thirdLevel].view;
        } else if (secondLevel !== null) {
          element.modules[secondLevel].view = !element.modules[secondLevel].view;
        } else {
          element.view = !element.view;
        }
      }
      aux.push(element)
    });
    
    setMainModules(() => aux);
  }
  
  async function getData() {
    api.get("/api/profiles/getDataPage")
    .then((response) => {
      carregaModulos(response.data.permissoes);
      setCarrying(false);

    }).catch((error) => {
      showMessageError(error.response.data);
      setCarrying(false);
    });
  }
  
  async function carregaModulos(modules) {
    let module = "";
    let mainModules = [];

    modules.forEach(element => {
      module = element.nome.trim();

      if (!(module.indexOf('-') >= 0)) {
        mainModules.push(element);
      }
    });

    for (var i in mainModules) {
      mainModules[i].modules = [];
      mainModules[i].view = false; // Variável que controla Expandir / Extender

      modules.forEach(element => {
        module = element.nome.split("-");
        
        if ((module.length === 2) && (element.nome.indexOf(mainModules[i].nome) >= 0) && (element.nome.trim() !== mainModules[i].nome.trim())) {
          mainModules[i].modules.push(element);
        }
      });

      for (var k in mainModules[i].modules) {
        mainModules[i].modules[k].modules = [];
        mainModules[i].modules[k].view = false; // Variável que controla Expandir / Extender

        modules.forEach(element => {
          module = element.nome.split("-");
          
          if ((module.length === 3) &&  (element.nome.indexOf(mainModules[i].modules[k].nome) >= 0) && (element.nome.trim() !== mainModules[i].modules[k].nome.trim())) {
            if(element.nome.trim().split(' ' && '-')[1].trim() !== mainModules[i].modules[k].nome.split('-')[1].trim()){
              return false;
            }

            mainModules[i].modules[k].modules.push(element);

            return true;
          }
        });

        for (var j in mainModules[i].modules[k].modules) {
          mainModules[i].modules[k].modules[j].modules = [];
          mainModules[i].modules[k].modules[j].view = false; // Variável que controla Expandir / Extender

          modules.forEach(element => {
            module = element.nome.split("-");
            if ((module.length === 4) &&  (element.nome.indexOf(mainModules[i].modules[k].modules[j].nome) >= 0) && (element.nome.trim() !== mainModules[i].modules[k].modules[j].nome.trim())) {
              mainModules[i].modules[k].modules[j].modules.push(element);
            }
          });
        }
      }
    }
    
    setMainModules(mainModules);
  }

  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>
      <ReactTooltip />
            
      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <Title name="Cadastro de Perfis">
          <Link to="/profiles">
            <FaArrowAltCircleLeft data-tip="Voltar" color="#001675" className="arrowIcon" size={40} />
          </Link>
        </Title>
        <div className="container">
          <form className="form-profile customers">
            <div className="containerGroupData">
              <h2>Dados Cadastrais</h2>
              <hr></hr>
              <div className="divGroup">
                <div className="formDiv">
                  <label>Nome</label><br/>
                  <input type="text" placeholder="Nome" value={nome} onChange={ (e) => setNome(e.target.value) } disabled={view}/>
                </div>
              </div>
              <div className="divGroupMarginTop">
                {mainModules.length > 0 && <div>
                  {mainModules.map((item, index) => (
                    <div key={index} className="divGroupMarginTop">
                      {item.modules.length > 0 && 
                        <span>
                          {item.view === false && <a>
                            <FaPlus onClick={() => chengeView(index)}/>&nbsp;&nbsp;
                          </a>}
                          {item.view === true && <a>
                            <FaMinus onClick={() => chengeView(index)} />&nbsp;&nbsp;
                          </a>}
                        </span>
                      }
                      {item.modules.length === 0 && <a>
                        <FaMinus color="#FFF" />&nbsp;&nbsp;
                      </a>}
                      <input type="checkbox" checked={item.checked} value={item.id} onChange={ () => changeListPermission(index) } disabled={view}/> <label>{item.nome}</label>
                      {item.view && item.modules.length > 0 && <div className="divCheck">
                        {item.modules.map((second_item, second_index) => (
                          <div key={index}>
                            {second_item.modules.length > 0 &&
                              <span>
                                {second_item.view === false && <a>
                                  <FaPlus onClick={() => chengeView(index, second_index)} />&nbsp;&nbsp;
                                </a>}
                                {second_item.view === true && <a>
                                  <FaMinus onClick={() => chengeView(index, second_index)} />&nbsp;&nbsp;
                                </a>}
                              </span>
                            }
                            {second_item.modules.length === 0 && <a>
                              <FaMinus color="#FFF" />&nbsp;&nbsp;
                            </a>}
                            <input type="checkbox" checked={second_item.checked} value={second_item.id} onChange={ () => changeListPermission(index, second_index) } disabled={view}/> <label>{second_item.nome}</label>
                            {second_item.view && second_item.modules.length > 0 && <div className="divCheck">
                              {second_item.modules.map((third_item, third_index) => (
                                <div key={index}>
                                  {third_item.modules.length > 0 &&
                                    <span>
                                      {third_item.view === false && <a>
                                        <FaPlus onClick={() => chengeView(index, second_index, third_index)} />&nbsp;&nbsp;
                                      </a>}
                                      {third_item.view === true && <a>
                                        <FaMinus onClick={() => chengeView(index, second_index, third_index)} />&nbsp;&nbsp;
                                      </a>}
                                    </span>
                                  }
                                  {third_item.modules.length === 0 && <a>
                                    <FaMinus color="#FFF" />&nbsp;&nbsp;
                                  </a>}                   
                                  <input type="checkbox" checked={third_item.checked} value={third_item.id} onChange={ () => changeListPermission(index, second_index, third_index) } disabled={view}/> <label>{third_item.nome}</label>
                                  {third_item.view && third_item.modules.length > 0 && <div className="divCheck">
                                    {third_item.modules.map((fourth_item, fourth_index) => (
                                      <div key={index}>
                                        <FaMinus color="#FFF" />&nbsp;&nbsp;
                                        <input type="checkbox" checked={fourth_item.checked} value={fourth_item.id} onChange={ () => changeListPermission(index, second_index, third_index, fourth_index) } disabled={view}/> <label>{fourth_item.nome}</label>
                                      </div>
                                    ))}
                                  </div>}
                                </div>
                              ))}
                            </div>}
                          </div>
                        ))}
                      </div>}
                    </div>
                  ))}
                </div>}
              </div>
            </div>
            {!view && <div className="formDiv">
              {getPermission('CADASTROS - PERFIS - CADASTRO') && <button type="submit" className="buttonSubmit" onClick={save} disabled={view}>Salvar</button>}
              <button type="button" className="buttonCancel" onClick={cancel} disabled={view}>Cancelar</button>
              {id && getPermission('CADASTROS - PERFIS - EXCLUSAO') && <button type="button" className="buttonRemove" onClick={remove} disabled={view}>Excluir</button>}
            </div>}
          </form>
        </div>
      </div>}
    </div>
  )
}